import { Feature, Map } from "ol";
import { getWidth } from "ol/extent";
import Geometry from "ol/geom/Geometry";
import MultiPolygon from "ol/geom/MultiPolygon";
import { Fill, Stroke, Style, Text } from "ol/style";
import React from "react";
import { useVectorLayer } from "~/pages/MapPage/functions/useVectorLayer";
import { GeojsonAttributes } from "./useProjectShapeFile";

export const useCellNamePolygon = ({
  features,
  enabled = false,
  map,
}: {
  features: Feature<Geometry>[];
  map: Map | undefined;
  enabled?: boolean;
}) => {
  const { layerSource, vectorLayer } = useVectorLayer({ map });

  React.useEffect(() => {
    if (!vectorLayer || !layerSource) return;
    if (!enabled || features.length < 1) {
      layerSource.clear();
      return;
    }
    layerSource.clear();
    layerSource?.addFeatures(features);
    vectorLayer.setZIndex(755);
    vectorLayer.setStyle((feature) => {
      return [
        new Style({
          text: new Text({
            text: (feature.getProperties() as GeojsonAttributes)?.SubArea ?? "",
            scale: 1.9,
            fill: new Fill({ color: "white" }),
            stroke: new Stroke({ color: "black" }),
            overflow: true,
            // backgroundFill: new Fill({ color: "black" }),
          }),
          zIndex: 725,
          geometry: (f) => {
            let geometry = f.getGeometry();
            if (geometry?.getType() === "MultiPolygon" && geometry) {
              // Only render label for the widest polygon of a multipolygon

              const polygons = (geometry as MultiPolygon).getPolygons();
              let widest = 0;
              for (let i = 0; i < polygons.length; ++i) {
                const polygon = polygons[i];
                const width = getWidth(polygon.getExtent());
                if (width > widest) {
                  widest = width;
                  geometry = polygon;
                }
              }
            }
            return geometry;
          },
        }),
      ];
    });
  }, [enabled, features, layerSource, vectorLayer]);
};
